module.exports = __webpack_public_path__ + "img/MINI.3c008df.jpg";